<template>
  <el-card class="pet-detail-card">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-image :src="pet.image" fit="cover" class="pet-image" />
      </el-col>
      <el-col :span="8">
        <div class="pet-info-container">
          <div class="pet-info">
            <p>{{ pet.name }}</p>
            <p>¥{{ pet.price }}</p>
            <p>性别：{{ pet.sex }}</p>
            <p>生日：{{ pet.birthday }}</p>
            <p>地区：{{ pet.region }}</p>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="action-info-container">
          <div v-if="pet.owner" class="seller-info">
            <el-avatar
              :src="pet.owner.avatar"
              class="owner-avatar"
              @click="showDialog"
            />
            <div>{{ pet.owner.name }}</div>
          </div>
          <div class="delivery-info">
            <el-tag type="success">买家自提</el-tag>
            <el-tag type="success">汽车配送</el-tag>
            <el-tag type="success">航空配送</el-tag>
          </div>
          <div class="purchase-button">
            <el-button type="warning" size="small" @click="showDialog">
              在线购买
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="pet-video">
          <video controls class="pet-video-element">
            <source :src="pet.video" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </el-col>
    </el-row>
  </el-card>

  <!-- 使用 v-model 替代 v-model:visible -->
  <el-dialog v-model="dialogVisible" title="提示" width="300px">
    <img
      src="@/assets/common/OfficialAccounts.png"
      alt="Official Accounts"
      class="official-accounts"
    />
    <p>请进入小程序购买</p>
    <template #footer>
      <el-button @click="dialogVisible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import {
  ElCard,
  ElRow,
  ElCol,
  ElImage,
  ElButton,
  ElAvatar,
  ElTag,
  ElDialog,
} from "element-plus";

const route = useRoute();
const pet = ref({});
const dialogVisible = ref(false);

onMounted(() => {
  const petData = route.query.pet;
  if (petData) {
    try {
      pet.value = JSON.parse(decodeURIComponent(petData));
      console.log("Parsed pet data:", pet.value);
    } catch (error) {
      console.error("Error parsing pet data:", error);
    }
  }
});

const showDialog = () => {
  dialogVisible.value = true;
  console.log("Dialog visibility set to:", dialogVisible.value); // 添加调试信息
};
</script>

<style scoped>
.pet-detail-card {
  max-width: 60%;
  margin: 0 auto;
}

.el-card-body {
  display: flex;
  flex-direction: column;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  padding: 0 10px;
}

.el-image {
  border-radius: 5px;
}

.pet-image {
  width: 80%;
  height: 200px; /* 减小图片高度 */
  object-fit: cover;
}

.pet-info-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.pet-name {
  font-size: 1.5em;
  margin-bottom: 10px;
}

.pet-info {
  text-align: left;
}

.action-info-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.seller-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.owner-avatar {
  margin-right: 10px;
  cursor: pointer; /* 添加鼠标指针样式 */
}

.delivery-info {
  display: flex;
  gap: 5px;
}

.purchase-button {
  margin-top: auto; /* 将购买按钮推到最底部 */
}

.pet-video {
  margin-top: 20px;
  width: 50%;
  height: 0;
  padding-bottom: 50%; /* 使视频容器成为正方形 */
  position: relative;
  margin: 0 auto; /* 居中 */
}

.pet-video video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.official-accounts {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.dialog-footer {
  text-align: right;
}

/* 添加调试样式 */
.el-dialog {
  z-index: 9999; /* 确保对话框在最上层 */
  background-color: rgba(255, 255, 255, 0.9); /* 半透明背景 */
  border: 2px solid red; /* 添加红色边框以便于调试 */
}
</style>
